import rankingRouter from "./ranking";

const payRouter = [
  {
    path: '/shop/pay',
    name: 'Pay',
    meta: {
      title: '订单信息'
    },
    component: () => import('@/views/pay/index.vue')
  },
  {
    path: '/buyMember',
    name: 'BuyMember',
    component: () =>
        import('@/views/pay/buyMember.vue'),
    meta: {
      title: '会员订单'
    }
  },
  {
    path: '/wxPay',
    name: 'WxPay',
    component: () =>
        import('@/views/pay/wxPay.vue'),
    meta: {
      title: '微信支付'
    }
  },
  {
    path: '/paySuccess',
    name: 'PaySuccess',
    component: () =>
        import('@/views/pay/paySuccess.vue'),
    meta: {
      title: '支付成功'
    }
  },
  {
    path: '/agreement',
    name: 'Agreement',
    component: () =>
        import('@/views/pay/agreement.vue'),
    meta: {
      title: '商城付费协议'
    }
  }
]
export default payRouter

